import { Button } from "@mui/material";
import { Modal } from "components/Modal";
import { useState } from "react";
import classes from "./style.module.scss";

export const CreateUpgradeUserModal = ({ open, onClose, selectedUser, onConfirm }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (!selectedUser?.id) return;

    setLoading(true);
    try {
      await onConfirm(selectedUser.id);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      title="تبدیل کاربر به ایجنت"
      onClose={onClose}
      maxWidth="sm"
      footerEnd={
        <>
          <Button
            variant="contained"
            size="xsmall"
            loading={loading}
            color="success"
            onClick={handleConfirm}
          >
            بله
          </Button>
          <Button variant="contained" color="error" size="xsmall" onClick={onClose}>
            خیر
          </Button>
        </>
      }
    >
      <div className={classes.wrapper}>
        آیا از تبدیل کاربر با ایمیل {selectedUser?.email} به ایجنت مطمئن هستید؟
      </div>
    </Modal>
  );
};
